import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/5rtHZUgQD2bv2iapiJEGC2/Mockup.png';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-63" data-mp="4lqjixa15f41">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-64" data-mp="129h19owp12dy" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-65" data-mp="1274l9hahx23j">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-66" data-mp="xaxe5l6d5kk0">
          🌿BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-2xl font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-67" data-mp="3d21rzwjzqin7">
          Calmá la hinchazón y los gases del SIBO en 14 días,{' '}
          <span className="text-brand-light" data-id="element-68" data-mp="3o6aphuku24zf">
            sin dietas eternas ni prueba y error.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-69" data-mp="39cfjqxfz4vsg">
          <img src={mockupUrl} alt="Mockup del Protocolo Rescate SIBO con sus páginas interiores" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-70" data-mp="358rbsdnfjy6o" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-71" data-mp="2hk85g3nxxvh8">
          <p className="font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-72" data-mp="s335tfryasyl">
            🏆 PROTOCOLO RESCATE SIBO™
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-73" data-mp="n9i35afexat2">
            Sistema completo de 300+ páginas, paso a paso, para personas que
            conviven con SIBO y ya probaron de todo sin resultados claros.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-74" data-mp="1azullf8aapxw">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-75" data-mp="162c7zbjbnmjk">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-76" data-mp="114svag29vhtq" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-77" data-mp="x3h0zx8ge8f7">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-78" data-mp="3hrlosum1wtes" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-79" data-mp="1xaw06rmvemay">
          <ActionButton href="#pricing" showTrust data-id="element-80" data-mp="268oebsguvnwr">
            QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}